<div class="containerBanner">
  <div class="menu-container">
    <!-- @if(showServiceRequestTable){
        <h1>Admin Requests<span>({{ this.totalForwarded}})</span></h1>
      } -->
    @if(showForwardedReqTable){
    <h1>
      Forwarded Service Request<span>({{ this.totalserviceForwarded }})</span>
    </h1>
    } @if(showNewForwardedReqTable && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showForwardedReqTable){
    <h1>
      Forwarded New Request<span>({{ this.totalNewReqForwarded }})</span>
    </h1>

    }
    @if(showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showNewForwardedReqTable && !showForwardedReqTable){
    <h1>
      Approved Forwarded Service Request<span>({{ this.totalApprovedForwardedServiceReq }})</span>
    </h1>
    } @if(showApprovedNewForwardedReqTable && !showApprovedForwardedServiceReq && !showNewForwardedReqTable && !showForwardedReqTable){
    <h1>
      Approved Forwarded New Request<span>({{ this.totalApprovedNewReqForwarded }})</span>
    </h1>
    }
    @if(showDeclinedForwardedServiceReq && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showNewForwardedReqTable && !showForwardedReqTable){
      <h1>
        Declined Forwarded Service Request<span>({{ this.totalDeclinedForwardedServiceReq }})</span>
      </h1>
    }
    @if(showDeclinedForwardedNewReq && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showNewForwardedReqTable && !showForwardedReqTable){
      <h1>
        Declined Forwarded New Request<span>({{ this.totalDeclinedForwardedNewReq }})</span>
      </h1>
    }
    <div
      class="menu-content d-flex align-items-center justify-content-between"
      style="margin-bottom: 15px"
    >
      <div class="search-menu">
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="search-icon"
        >
          <g opacity="0.4">
            <circle
              cx="11.0795"
              cy="11.3768"
              r="7.62168"
              transform="rotate(-45 11.0795 11.3768)"
              stroke="#092C4C"
              stroke-width="1.72802"
              stroke-linecap="round"
            />
            <path
              d="M16.6416 16.9393L19.8465 20.1443"
              stroke="#092C4C"
              stroke-width="1.72802"
              stroke-linecap="round"
            />
          </g>
        </svg>
        @if(showForwardedReqTable && !showNewForwardedReqTable && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable){
        <input
          type="search"
          [(ngModel)]="forwardedSearchQuery"
          (keydown.enter)="onSearchForwardedInventory()"
          placeholder="Search Forwarded Requests"
        />
        @if(forwardedSearchQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearForwardedSearch()"
        />} }
         @if(showNewForwardedReqTable && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showForwardedReqTable){
        <input
          type="search"
          [(ngModel)]="newforwardedSearchQuery"
          (keydown.enter)="onSearchNewForwardedInventory()"
          placeholder="Search Forwarded Requests"
        />
        @if(newforwardedSearchQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearNewForwardedSearch()"
        />} }

        @if(showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable){
        <input
          type="search"
          [(ngModel)]="appForwarServiceReqQuery"
          (keydown.enter)="getApprovedForwardServiceReq('Service Request')"
          placeholder="Search Forwarded Requests"
        />
        @if(appForwarServiceReqQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearappForwarServiceReq()"
        />} }


         @if(showApprovedNewForwardedReqTable && !showApprovedForwardedServiceReq){
        <input
          type="search"
          [(ngModel)]="approvedForwardedNewReqQuery"
          (keydown.enter)="getApprovedForwardNewReq('New Inventory Request')"
          placeholder="Search Forwarded Requests"
        />
        @if(approvedForwardedNewReqQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearApprovedForwardedNewReq()"
        />} }
        @if(showDeclinedForwardedServiceReq && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showNewForwardedReqTable && !showForwardedReqTable){
          <input
            type="search"
            [(ngModel)]="declinedForwardedServiceReqQuery"
            (keydown.enter)="getDeclinedForwardServiceReq('Service Request')"
            placeholder="Search Forwarded Requests"
          />
          @if(declinedForwardedServiceReqQuery){
          <img
            class="search-close"
            style="cursor: pointer"
            src="../../../assets/closeIcon.png"
            alt=""
            (click)="clearDeclinedForwardedServiceReq()"
          />} }

          @if(showDeclinedForwardedNewReq && !showApprovedForwardedServiceReq && !showApprovedNewForwardedReqTable && !showNewForwardedReqTable && !showForwardedReqTable){
            <input
              type="search"
              [(ngModel)]="declinedForwardedNewReqQuery"
              (keydown.enter)="getDeclinedForwardNewReq('New Inventory Request')"
              placeholder="Search Forwarded Requests"
            />
            @if(declinedForwardedNewReqQuery){
            <img
              class="search-close"
              style="cursor: pointer"
              src="../../../assets/closeIcon.png"
              alt=""
              (click)="clearDeclinedForwardedNewReq()"
            />} }

      </div>
      <div
        class="btn-container filter-btn d-flex align-items-center justify-content-between"
      >
        <div class="mat-dropdown-panel">
          <mat-form-field
            style="width: 185px !important; height: 45px !important"
          >
            <mat-select [(value)]="selectedForwardDropdownValue" placeholder="Forwarded service Request">
            
              @for (forward of serviceForward; track $index) {
              <mat-option
                [value]="forward.value"
                (click)="onForwardSelect(forward.value)"
              >
                {{ forward.viewValue }}
              </mat-option>
              } @for (newforward of newForwardRequest; track $index) {
              <mat-option
                [value]="newforward.value"
                (click)="onForwardSelect(newforward.value)"
              >
                {{ newforward.viewValue }}
              </mat-option>
              }

              <mat-option
                value ="Service Request"
                (click)="getApprovedForwardServiceReq('Service Request')"
              >
              Approved Service Request
              </mat-option>

               <mat-option
                value ="New Inventory Request"
                (click)="getApprovedForwardNewReq('New Inventory Request')"
              >
              Approved New Request
              </mat-option>
               <mat-option
                value ="Service Request"
                (click)="getDeclinedForwardServiceReq('Service Request')"
              >
              Declined Service Request
              </mat-option>
              <mat-option
                value ="New Inventory Request"
                (click)="getDeclinedForwardNewReq('New Inventory Request')"
              >
              Declined New Request
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- service Request Table -->
  <!-- @if( showServiceRequestTable){
    <div class="checked-out-inv" style="overflow: auto;max-height: calc(100vh - 160px)">
        <table class="fixed-header-table" style="height: 660px;">
            <thead>
                <tr>
                    <th scope="col">ASSET NAME</th>
                    <th scope="col">REQUESTED BY</th>
                    <th scope="col">STATUS</th>
                    @if(showNewInv){
                    <th scope="col">LINKS</th>
                    }
                    @if(showService){
                    <th scope="col">SERVICE TYPE</th>
                    <th scope="col">DAMAGE</th>
                    <th scope="col">OTHER DETAILS</th>
                    }
                    <th scope="col">REQUESTED ON</th>
                    <th scope="col">NEED BY</th>
                    <th scope="col">URGENCY</th>
                    <th scope="col">FORWARDED ON</th>
                    <th scope="col">FORWARDED BY</th>
                    <th scope="col">MAXIMUM COST(₹)</th>
                    <th scope="col">ACTIONS</th>

                </tr>
            </thead>
            <tbody>
                @for (adminReq of adminRequest; track $index) {
                <tr>
                    <td>
                        <div class="d-flex align-items-center">
                            <div class="inventory-img">
                              @if(showService){
                                <img src="../../../assets/inventories/computer-system.jpg" alt="" width="60px"
                                    height="60px" />
                              }
                            </div>
                            <p>{{adminReq.assetCategory}}</p>
                        </div>
                    </td>
                    <td>
                        <p>{{adminReq.requestedBy}}</p>
                    </td>
                    <td>
                        <p class="status">{{adminReq.status}}</p>
                    </td>
                    @if(showNewInv){
                    <td>
                        <p class="link"><a [href]="adminReq.links[0]">{{adminReq.links[0]!== "null" ?
                                adminReq.links[0] : '-' }}</a></p>
                        <p class="link"><a [href]="adminReq.links[1]">{{adminReq.links[1]!== "null" ?
                                adminReq.links[1] : ''}}</a></p>
                        <p class="link"><a [href]="adminReq.links[2]">{{adminReq.links[2]!== "null" ?
                                adminReq.links[2] : ''}}</a></p>
                    </td>
                    }
                    @if(showService){
                    <td>
                        <p>{{adminReq.serviceType}}</p>
                    </td>
                    <td>
                        <p>{{adminReq.damage}}</p>
                    </td>
                    <td>
                        <p class="other-details">
                            {{adminReq.details}}
                        </p>
                    </td>
                    }
                    <td>
                        <p>{{adminReq.requestedOn}}</p>
                    </td>
                    <td>
                        <p>{{adminReq.needBy}}</p>
                    </td>

                    <td>
                        <p [ngClass]="{
                            'text-red':adminReq.urgency === 'High',
                            'text-orange':adminReq.urgency === 'Medium',
                            'text-blue':adminReq.urgency === 'Low'
                          }">{{adminReq.urgency}}</p>
                    </td>
                    <td>
                        <p>{{adminReq.forwardedOn}}</p>
                    </td>
                    <td>
                        <p>{{adminReq.forwardedBy}}</p>
                    </td>

                    <td>
                      
                        <p>₹{{formatCurrency(adminReq?.maximumCost)}}</p>
                    </td>


                    <td>
                        <button class="accept" data-toggle="modal" data-target="#acceptRequestConfirm"
                            style="width: 140px;margin-right: 15px;">
                            Accept
                        </button>
                        <button class="on-hold" style="margin-right: 10px;" data-toggle="modal" data-target="#onHoldConfirm">Put on Hold</button>
                        <button class="decline" style="width: 140px;" data-toggle="modal" data-target="#declineRequestConfirm">Decline</button>
                    </td>
                </tr>
                }
            </tbody>

            @if(this.adminRequest.length === 0){
            <app-no-data></app-no-data>
           }  
        </table>
    </div>
  } -->
  <!-- Forward service Request Table -->
  @if (showForwardedReqTable) {
  <div
    class="checked-out-inv"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 680px;
      overflow-x: scroll;
    "
  >
    <table class="fixed-header-table" style="overflow-x: unset !important">
      <thead>
        <tr>
          <th scope="col">ASSET NAME</th>
          <th scope="col">REQUESTED BY</th>
          <th scope="col">APPROVER</th>
          <th scope="col">STATUS</th>
          <th scope="col">SERVICE TYPE</th>
          <th scope="col">DAMAGE</th>
          <th scope="col">OTHER DETAILS</th>
          <th scope="col">REQUESTED ON</th>
          <th scope="col">NEED BY</th>
          <th scope="col">URGENCY</th>
          <th scope="col">FORWARDED ON</th>
          <th scope="col">FORWARDED TO</th>
          <th scope="col">COMMENT</th>
          <th scope="col">ACTION</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of forwardedReq; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>
              <div class="inventory-img">
                <img
                  data-toggle="modal"
                  data-target="#forwardServiceSliderModal"
                  (click)="openforwardServiceSlider($index)"
                  [src]="
                    forward.assetImage && forward.assetImage !== '0'
                      ? forward.assetImage
                      : '../../../../assets/inventories/default-inventory.png'
                  "
                  alt=""
                  width="60px"
                  height="60px"
                />
              </div>
              <p>{{ forward.assetName }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td>
          <td>
            <p class="status-point">{{ forward.status }}</p>
          </td>
          <td>
            <p>{{ forward.serviceType }}</p>
          </td>
          <td>
            <p>{{ forward.damage }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.details }}
            </p>
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p class="urgency">{{ forward.urgency }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>

          <td>
            <button
              class="accept"
              data-toggle="modal"
              data-target="#acceptRequestConfirm"
              style="width: 140px; margin-right: 15px"
              (click)="openServiceAccept(); selectedRequest = forward"
            >
              Accept
            </button>
            <!-- <button class="on-hold"  style="margin-right: 10px;" data-toggle="modal" data-target="#onHoldConfirm" [disabled]="onHoldRequestIds.includes(forward.requestId)">Put on -->
            <!-- Hold</button> -->
            <button
              class="decline"
              style="width: 140px"
              data-toggle="modal"
              data-target="#declineRequestConfirm"
              (click)="openServiceAccept(); selectedRequest = forward"
            >
              Decline
            </button>
          </td>
        </tr>
        }
      </tbody>
         @if(forwardedReq.length === 0){
    <app-no-data></app-no-data>
    }
    </table>
 
  </div>
  }
   @if (showNewForwardedReqTable) {
  <div
    class="checked-out-inv"
    style="
      overflow-x: auto;
      overflow-y: scroll;
      max-height: calc(100vh - 160px);
      min-height: 660px;
      overflow-x: scroll;
    "
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
  >
    <table class="fixed-header-table" style="overflow-x: unset !important">
      <thead>
        <tr>
          <th scope="col" style="width: 15%">ASSET NAME</th>
          <th scope="col" style="width: 15%">REQUESTED BY</th>
          <th scope="col" style="width: 15%">APPROVER</th>
          <th scope="col" style="width: 15%">STATUS</th>
          <th scope="col" style="width: 15%">LINKS</th>
          <th scope="col" style="width: 15%">REQUESTED ON</th>
          <th scope="col" style="width: 15%">NEED BY</th>
          <th scope="col" style="width: 15%">URGENCY</th>
          <th scope="col" style="width: 15%">FORWARDED ON</th>
          <th scope="col" style="width: 15%">FORWARDED TO</th>
          <th scope="col">COMMENT</th>
          <th scope="col">ACTION</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of forwardedReq; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>
              <p>{{ forward.assetType }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td>
          <td>
            <p>
              {{ forward.status }}
            </p>
          </td>
          <td>
            @if(forward.links[0] && forward.links[0] !== 'null'){
            <p class="link">
              <a [href]="forward.links[0]">{{
                forward.links[0] !== "null" ? forward.links[0] : "-"
              }}</a>
            </p>
            } @if(forward.links[1] && forward.links[1] !== 'null'){
            <p class="link">
              <a [href]="forward.links[1]">{{
                forward.links[1] !== "null" ? forward.links[1] : ""
              }}</a>
            </p>
            } @if(forward.links[2] && forward.links[2] !== 'null'){

            <p class="link">
              <a [href]="forward.links[2]">{{
                forward.links[2] !== "null" ? forward.links[2] : ""
              }}</a>
            </p>
            }
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p
              [ngClass]="{
                'text-red': forward.urgency === 'High',
                'text-orange': forward.urgency === 'Medium',
                'text-blue': forward.urgency === 'Low'
              }"
            >
              {{ forward.urgency }}
            </p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>

          <td>
            <button
              class="accept"
              data-toggle="modal"
              data-target="#acceptRequestConfirm"
              style="width: 140px; margin-right: 15px"
              (click)="openNewAccept(); selectedRequest = forward"
            >
              Accept
            </button>
            <!-- <button class="on-hold" style="margin-right: 10px;" data-toggle="modal" data-target="#onHoldConfirm">Put on
              Hold</button> -->
            <button
              class="decline"
              style="width: 140px"
              data-toggle="modal"
              data-target="#declineRequestConfirm"
              (click)="openNewAccept(); selectedRequest = forward"
            >
              Decline
            </button>
          </td>
        </tr>
        }
      </tbody>
      @if(forwardedReq.length === 0){
      <app-no-data></app-no-data>
      }
    </table>
  </div>
  }


  <!-- Accept Request Modal -->
  <div
    class="modal fade"
    id="acceptRequestConfirm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="acceptRequestConfirmTitle"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered accept-width-content"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body" style="padding: 90px 20px 20px 20px">
          @if(!showAcceptSuccess){
          <div>
            <h1 class="text-center" style="font-size: 28px; font-weight: 600">
              Accept Request?
            </h1>
            <p
              class="text-center"
              style="font-size: 16px; font-weight: 600; opacity: 0.5"
            >
              Are you sure you want to approve the request?
            </p>
            @if(showService){
            <button
              type="button"
              class="confirm"
              (click)="acceptRequest(selectedRequest.requestId)"
            >
              Confirm
            </button>
            } @if(showNewInv){
            <button
              type="button"
              class="confirm"
              (click)="acceptNewInvRequest(selectedRequest.requestId)"
            >
              Confirm
            </button>
            }
          </div>
          } @if(showAcceptSuccess){
          <div style="text-align: center; padding-bottom: 40px">
            <svg
              width="76"
              height="76"
              viewBox="0 0 76 76"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M38.0024 4.17479C46.2915 4.17479 54.2979 7.18819 60.53 12.6536C66.7621 18.1189 70.7947 25.6635 71.8767 33.8817C72.9586 42.0998 71.016 50.4311 66.4109 57.3232C61.8057 64.2153 54.852 69.1983 46.8454 71.3436C38.8388 73.489 30.3252 72.6505 22.891 68.9843C15.4567 65.3182 9.60879 59.0744 6.4367 51.4163C3.2646 43.7582 2.9847 35.208 5.64913 27.3588C8.31357 19.5097 13.7406 12.8968 20.9192 8.75224"
                stroke="#24BA61"
                stroke-width="6.40622"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M25.1914 38.3414L33.733 46.8831L50.8163 29.7998"
                stroke="#24BA61"
                stroke-width="5.33852"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h3 style="font-size: 24px; font-weight: 700; color: #030303">
              Request Approved
            </h3>
            <p
              class="text-center"
              style="font-size: 16px; font-weight: 600; opacity: 0.5"
            >
              Request has been approved, admin and the user will be notified
              about this
            </p>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
 

  <!-- On Hold Modal -->
  @for(adminreq of adminRequest; track $index){
  <div
    class="modal fade"
    id="onHoldConfirm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="onHoldConfirmTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered accept-width-content"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body" style="padding: 50px 20px 50px 20px">
          <h1 class="text-center" style="font-size: 28px; font-weight: 600">
            Put On Hold Till
          </h1>
          <form
            style="margin: 45px 0; display: flex; justify-content: center"
            [formGroup]="onHoldForm"
          >
            <input
              type="date"
              id="onHoldTillDate"
              [min]="today"
              class="form-control"
              style="width: 340px; padding: 15px; height: 42px"
              formControlName="onHoldTillDate"
            />
          </form>
          @if(showService){
          <button
            type="button"
            class="onhold-confirm close d-flex m-auto"
            data-dismiss="modal"
            aria-label="Close"
            (click)="onHoldConfirm(adminreq.requestId)"
            style="opacity: 1"
          >
            Confirm
          </button>
          } @if(showNewInv){
          <button
            type="button"
            class="onhold-confirm close d-flex m-auto"
            data-dismiss="modal"
            aria-label="Close"
            (click)="onHoldNewInvConfirm(adminreq.requestId)"
            style="opacity: 1"
          >
            Confirm
          </button>
          }
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Decline Request Modal  -->
  <div
    class="modal fade"
    id="declineRequestConfirm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="declineRequestConfirmTitle"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered accept-width-content"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <div class="modal-body" style="padding: 90px 20px 20px 20px">
          <div class="reject-container">
            @if(showDeclineModal){
            <h6
              style="
                padding-bottom: 6px;
                text-align: center;
                font-weight: 600;
                font-size: 24px;
              "
            >
              Reject Request
            </h6>
            <p>Are you sure you want to reject the request?</p>
            <div class="textarear-parent" style="padding: 0 30px">
              <form [formGroup]="declineReasonForm">
                <div
                  class="reject-textarea d-flex flex-column justify-content-center"
                  style="margin: 0 auto; width: 650px"
                >
                  <label for="rejectionReason">Comment</label>
                  <textarea
                    id="rejectionReason"
                    name="contact"
                    rows="3"
                    formControlName="rejectionReason"
                    required
                    style="width: 600px"
                  >
                  </textarea>
                </div>
                @if(showService){
                <button
                  class="11 btn btn-decline d-flex justify-content-center align-items-center"
                  style="margin: 30px auto; padding: 15px 60px"
                  (click)="onDeclineRequest(selectedRequest.requestId)"
                >
                  Confirm
                </button>
                } @if(showNewInv){
                <button
                  class="btn btn-decline d-flex justify-content-center align-items-center"
                  style="margin: 30px auto; padding: 15px 60px"
                  (click)="onDeclineNewInvRequest(selectedRequest.requestId)"
                >
                  Confirm
                </button>
                }
              </form>
            </div>
            } @if(showRejectConfirm){
            <div class="" style="text-align: center; padding-bottom: 40px">
              <svg
                width="76"
                height="76"
                viewBox="0 0 76 76"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.0024 4.17479C46.2915 4.17479 54.2979 7.18819 60.53 12.6536C66.7621 18.1189 70.7947 25.6635 71.8767 33.8817C72.9586 42.0998 71.016 50.4311 66.4109 57.3232C61.8057 64.2153 54.852 69.1983 46.8454 71.3436C38.8388 73.489 30.3252 72.6505 22.891 68.9843C15.4567 65.3182 9.60879 59.0744 6.4367 51.4163C3.2646 43.7582 2.9847 35.208 5.64913 27.3588C8.31357 19.5097 13.7406 12.8968 20.9192 8.75224"
                  stroke="#F74A4A"
                  stroke-width="6.40622"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M29.8711 46.8831L46.9544 29.7998"
                  stroke="#F74A4A"
                  stroke-width="5.33852"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M29.8699 29.7998L46.9531 46.8831"
                  stroke="#F74A4A"
                  stroke-width="5.33852"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h3>Request Rejected</h3>
              <p>
                Request has been rejected, admin and the user will be notified
                about this!
              </p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>



  <!--APPROVED FORWARDED SERVICE REQUEST  -->
  @if (showApprovedForwardedServiceReq) {
   <div
    class="checked-out-inv"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollServiceForwarded()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 705px;
      overflow-x: scroll;
    "
  >
    <table class="fixed-header-table" style="overflow-x: unset !important">
      <thead>
        <tr>
          <th scope="col">ASSET NAME</th>
          <th scope="col">REQUESTED BY</th>
          <th scope="col">APPROVER</th>
          <th scope="col">STATUS</th>
          <th scope="col">SERVICE TYPE</th>
          <th scope="col">DAMAGE</th>
          <th scope="col">OTHER DETAILS</th>
          <th scope="col">REQUESTED ON</th>
          <th scope="col">NEED BY</th>
          <th scope="col">URGENCY</th>
          <th scope="col">FORWARDED ON</th>
          <th scope="col">FORWARDED TO</th>
          <th scope="col">COMMENT</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of approvedForwardedServiceReq; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>
              <div class="inventory-img">
                <img
                  data-toggle="modal"
                  data-target="#forwardServiceSliderModal"
                  (click)="openforwardServiceSlider($index)"
                  [src]="
                    forward.assetImage && forward.assetImage !== '0'
                      ? forward.assetImage
                      : '../../../../assets/inventories/default-inventory.png'
                  "
                  alt=""
                  width="60px"
                  height="60px"
                />
              </div>
              <p>{{ forward.assetName }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td>
          <td>
            <p class="status-point">{{ forward.status }}</p>
          </td>
          <td>
            <p>{{ forward.serviceType }}</p>
          </td>
          <td>
            <p>{{ forward.damage }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.details }}
            </p>
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p class="urgency">{{ forward.urgency }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if(approvedForwardedServiceReq.length === 0){
    <app-no-data></app-no-data>
    }
  </div>
}

  <!--APPROVED FORWARDED NEW REQUEST  -->
  @if (showApprovedNewForwardedReqTable && !showForwardedReqTable) {
   <div
    class="checked-out-inv"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollForwarded()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 705px;
      overflow-x: scroll;
    "
  >
    <table class="fixed-header-table" style="overflow-x: unset !important">
      <thead>
        <tr>
          <th scope="col" width="200">ASSET NAME</th>
          <th scope="col" width="200">REQUESTED BY</th>
          <th scope="col" width="200">APPROVER</th>
          <th scope="col" width="200">STATUS</th>
          <th scope="col" width="200">REQUESTED ON</th>
          <th scope="col" width="200">NEED BY</th>
          <th scope="col" width="200">URGENCY</th>
          <th scope="col" width="200">FORWARDED ON</th>
          <th scope="col" width="200">FORWARDED TO</th>
          <th scope="col" width="200">COMMENT</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of approvedNewForwardedInventory; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>

              <p>{{ forward.assetType }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td>
          <td>
            <p class="status-point">{{ forward.status }}</p>
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p class="urgency">{{ forward.urgency }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if(approvedNewForwardedInventory.length === 0){
    <app-no-data></app-no-data>
    }
  </div>
}

  <!--DECLINED FORWARDED SERVICE REQUEST  -->
  @if (showDeclinedForwardedServiceReq) {
   <div
    class="checked-out-inv"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollServiceForwarded()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 705px;
      overflow-x: scroll;
    "
  >
    <table class="fixed-header-table" style="overflow-x: unset !important">
      <thead>
        <tr>
          <th scope="col">ASSET NAME</th>
          <th scope="col">REQUESTED BY</th>
          <!-- <th scope="col">APPROVER</th> -->
          <th scope="col">STATUS</th>
          <th scope="col">SERVICE TYPE</th>
          <th scope="col">DAMAGE</th>
          <th scope="col">OTHER DETAILS</th>
          <th scope="col">REQUESTED ON</th>
          <th scope="col">NEED BY</th>
          <th scope="col">URGENCY</th>
          <th scope="col">FORWARDED ON</th>
          <th scope="col">FORWARDED TO</th>
          <th scope="col">COMMENT</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of declinedForwardedServiceReq; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>
              <div class="inventory-img">
                <img
                  data-toggle="modal"
                  data-target="#forwardServiceSliderModal"
                  (click)="openforwardServiceSlider($index)"
                  [src]="
                    forward.assetImage && forward.assetImage !== '0'
                      ? forward.assetImage
                      : '../../../../assets/inventories/default-inventory.png'
                  "
                  alt=""
                  width="60px"
                  height="60px"
                />
              </div>
              <p>{{ forward.assetName }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <!-- <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td> -->
          <td>
            <p class="" style="color: red;">{{ forward.status }}</p>
          </td>
          <td>
            <p>{{ forward.serviceType }}</p>
          </td>
          <td>
            <p>{{ forward.damage }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.details }}
            </p>
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p class="urgency">{{ forward.urgency }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if(declinedForwardedServiceReq.length === 0){
    <app-no-data></app-no-data>
    }
  </div>
}

  <!--DECLINED FORWARDED NEW REQUEST  -->
  @if (showDeclinedForwardedNewReq) {
   <div
    class="checked-out-inv"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollServiceForwarded()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 705px;
      overflow-x: scroll;
    "
  >
    <table class="fixed-header-table" style="overflow-x: unset !important">
      <thead>
        <tr>
          <th scope="col" width="200px">ASSET TYPE</th>
          <th scope="col" width="200px">REQUESTED BY</th>
          <!-- <th scope="col">APPROVER</th> -->
          <th scope="col" width="200px">STATUS</th>
          <th scope="col" width="200px">LINKS</th>
          <th scope="col" width="200px">REQUESTED ON</th>
          <th scope="col" width="200px">NEED BY</th>
          <th scope="col" width="200px">URGENCY</th>
          <th scope="col" width="200px">FORWARDED ON</th>
          <th scope="col" width="200px">FORWARDED TO</th>
          <th scope="col" width="200px">COMMENT</th>
          <th scope="col" width="200px">REASON</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of declinedForwardedNewReq; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>
              <p>{{ forward.assetType }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <!-- <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td> -->
          <td>
            <p class="" style="color: red;">{{ forward.status }}</p>
          </td>
            <td>
            @if(forward.links[0] && forward.links[0] !== 'null'){
            <p class="link">
              <a [href]="forward.links[0]">{{ forward.links[0] }}</a>
            </p>
            } @if(forward.links[1] && forward.links[1] !== 'null'){
            <p class="link">
              <a [href]="forward.links[1]">{{ forward.links[1] }}</a>
            </p>
            } @if(forward.links[2] && forward.links[2] !== 'null'){
            <p class="link">
              <a [href]="forward.links[2]">{{ forward.links[2] }}</a>
            </p>
            }
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p class="urgency">{{ forward.urgency }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>
          <td>
            <p class="other-details" style="width: 180px;">
              {{ forward.rejectionReason || '-' }}
            </p>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if(declinedForwardedNewReq.length === 0){
    <app-no-data></app-no-data>
    }
  </div>
}

    <!-- Forwarded service Image Slider(HR) -->
<div class="modal fade" id="forwardServiceSliderModal" tabindex="-1" role="dialog" 
     aria-labelledby="forwardServiceSliderModal" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered img-preview-width" role="document">
    <div class="modal-content img-preview-slider">
      <div class="modal-header inv-slider-header">
        <button type="button" class="close inven-cls" data-dismiss="modal" aria-label="Close">
          <svg class="cross-svg" width="14" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5518 1.64453L1.85612 12.3402" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round"/>
            <path d="M12.5518 12.3401L1.85612 1.64445" stroke="#25252B" stroke-width="2.26313" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body img-preview-container">
        <div class="d-flex justify-content-between">
          <div class="product-carousel2">
            <!-- Only show carousel if there are multiple images -->
            @if(preview?.images?.length > 1) {
            <div id="carouselMyAssignedIndicators" class="carousel slide" data-ride="carousel">
              <ol class="carousel-indicators">
                @for (productImg of preview?.images; track $index) {
                <li data-target="#carouselMyAssignedIndicators" 
                    [attr.data-slide-to]="$index" 
                    [class.active]="$index === 0"></li>
                }
              </ol>
              <div class="carousel-inner">
                @for (productImg of preview?.images; track $index) {
                <div class="carousel-item" [class.active]="$index === 0">
                  <img [src]="productImg || '../../../assets/inventories/default-inventory.png'" 
                       class="d-block" alt="...">
                </div>
                }
              </div>
              <button class="carousel-control-prev" type="button" 
                      data-target="#carouselMyAssignedIndicators" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" 
                      data-target="#carouselMyAssignedIndicators" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </button>
            </div>
            }
            @else {
            <!-- Show simple image when there's only one -->
            <div class="single-image-container">
              <img [src]="preview?.images[0] || '../../../assets/inventories/default-inventory.png'" 
                   class="d-block" alt="...">
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
